/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Androidbeta_Registering1Inputs */

const id_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendaftarkan Anda untuk beta...`)
};

const ms_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendaftarkan anda untuk beta...`)
};

const da_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrerer dig til betaen...`)
};

const de_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie werden für die Beta registriert...`)
};

const en_us2_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering you for the beta...`)
};

const es_es2_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrándote para la beta...`)
};

const es_mx2_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrándote para la beta...`)
};

const fil_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inirerehistro ka para sa beta...`)
};

const fr_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription à la bêta en cours…`)
};

const it_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione in corso per la beta...`)
};

const hu_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regisztrálás a bétára...`)
};

const nl_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je registreren voor de bèta...`)
};

const no_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrerer deg for betaen...`)
};

const pl_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestracja do bety...`)
};

const pt_br2_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering you for the beta...`)
};

const pt_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A registá-lo na beta...`)
};

const ro_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te înregistrăm pentru beta...`)
};

const fi_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekisteröidään sinua betaan...`)
};

const sv_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrerar dig för betan...`)
};

const vi_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đăng ký bạn vào beta...`)
};

const tr_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta için kaydediliyor...`)
};

const cs_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrace do beta verze...`)
};

const bg_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистриране за бета версията...`)
};

const ru_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регистрация в бета-тесте...`)
};

const uk_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Реєстрація в бета-версії...`)
};

const ar_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تسجيلك في الإصدار التجريبي...`)
};

const hi_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पंजीकरण हो रहा है...`)
};

const th_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังลงทะเบียนคุณสำหรับเบต้า...`)
};

const ja_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベータ版に登録中...`)
};

const zh_cn2_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering you for the beta...`)
};

const zh_hant1_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering you for the beta...`)
};

const ko_forms_androidbeta_registering1 = /** @type {(inputs: Forms_Androidbeta_Registering1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registering you for the beta...`)
};

/**
* | output |
* | --- |
* | "Registering you for the beta..." |
*
* @param {Forms_Androidbeta_Registering1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_androidbeta_registering1 = /** @type {((inputs?: Forms_Androidbeta_Registering1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Androidbeta_Registering1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_androidbeta_registering1(inputs)
	if (locale === "ms") return ms_forms_androidbeta_registering1(inputs)
	if (locale === "da") return da_forms_androidbeta_registering1(inputs)
	if (locale === "de") return de_forms_androidbeta_registering1(inputs)
	if (locale === "en-US") return en_us2_forms_androidbeta_registering1(inputs)
	if (locale === "es-ES") return es_es2_forms_androidbeta_registering1(inputs)
	if (locale === "es-MX") return es_mx2_forms_androidbeta_registering1(inputs)
	if (locale === "fil") return fil_forms_androidbeta_registering1(inputs)
	if (locale === "fr") return fr_forms_androidbeta_registering1(inputs)
	if (locale === "it") return it_forms_androidbeta_registering1(inputs)
	if (locale === "hu") return hu_forms_androidbeta_registering1(inputs)
	if (locale === "nl") return nl_forms_androidbeta_registering1(inputs)
	if (locale === "no") return no_forms_androidbeta_registering1(inputs)
	if (locale === "pl") return pl_forms_androidbeta_registering1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_androidbeta_registering1(inputs)
	if (locale === "pt") return pt_forms_androidbeta_registering1(inputs)
	if (locale === "ro") return ro_forms_androidbeta_registering1(inputs)
	if (locale === "fi") return fi_forms_androidbeta_registering1(inputs)
	if (locale === "sv") return sv_forms_androidbeta_registering1(inputs)
	if (locale === "vi") return vi_forms_androidbeta_registering1(inputs)
	if (locale === "tr") return tr_forms_androidbeta_registering1(inputs)
	if (locale === "cs") return cs_forms_androidbeta_registering1(inputs)
	if (locale === "bg") return bg_forms_androidbeta_registering1(inputs)
	if (locale === "ru") return ru_forms_androidbeta_registering1(inputs)
	if (locale === "uk") return uk_forms_androidbeta_registering1(inputs)
	if (locale === "ar") return ar_forms_androidbeta_registering1(inputs)
	if (locale === "hi") return hi_forms_androidbeta_registering1(inputs)
	if (locale === "th") return th_forms_androidbeta_registering1(inputs)
	if (locale === "ja") return ja_forms_androidbeta_registering1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_androidbeta_registering1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_androidbeta_registering1(inputs)
	return ko_forms_androidbeta_registering1(inputs)
});
export { forms_androidbeta_registering1 as "forms.androidBeta.registering" }